import { render, staticRenderFns } from "./PassengerFlowYear.vue?vue&type=template&id=0ed5791e&scoped=true&"
import script from "./PassengerFlowYear.vue?vue&type=script&lang=js&"
export * from "./PassengerFlowYear.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFlowYear.vue?vue&type=style&index=0&id=0ed5791e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5791e",
  null
  
)

export default component.exports